import { atom, useAtom } from 'jotai';
import 'https://apis.google.com/js/api.js';
import { useEffect } from 'react';

// generate a url that asks permissions for Google Calendar scopes
const scopes = [
    'https://www.googleapis.com/auth/calendar',
    'https://www.googleapis.com/auth/calendar.readonly',
    'https://www.googleapis.com/auth/blogger',
    'https://www.googleapis.com/auth/meetings.space.readonly',
    'https://www.googleapis.com/auth/meetings.space.created',
    // 'https://www.googleapis.com/auth/drive.readonly'
]

export interface TokenClient {
    callback: (res: any) => void | Promise<void>
    requestCode: () => void
}

const tokenClientAtom = atom<TokenClient | undefined>(undefined)
const accountsLoading = atom(true)
export const useGoogleAccounts = () => {
    const [tokenClient, setTokenClient] = useAtom(tokenClientAtom)
    const [loading, setLoading] = useAtom(accountsLoading)

    useEffect(() => {
        let scriptAccounts: HTMLScriptElement

        scriptAccounts = document.createElement('script');
        scriptAccounts.src = "https://accounts.google.com/gsi/client";
        scriptAccounts.async = true;
        scriptAccounts.defer = true;
        scriptAccounts.onload = gisLoaded;

        document.body.appendChild(scriptAccounts);
    }, [])
    const gisLoaded = () => {
        const t = window.google.accounts.oauth2.initCodeClient({
            client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
            scope: scopes.join(' '),
            ux_mode: 'popup',
            callback: '', // defined later
        });
        setTokenClient(t)
        setLoading(false)
    }

    return [tokenClient, loading, null] as [TokenClient, boolean, null]
};

const gapiAtom = atom(true)
export const useGoogleApi = () => {
    const [loading, setLoading] = useAtom(gapiAtom)
    useEffect(() => {
        window.gapi.load('client', async () => {
            // logger.debug(import.meta.env.VITE_FIREBASE_API_KEY,import.meta.env.VITE_GOOGLE_CLIENT_ID)
            await window.gapi.client.init({
                apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
                // scope: 'profile',
                // clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
            })
            setLoading(false)
        });
    }, [])

    return [window.gapi, loading, null]
};
